<template>
  <div>
<!--    <v-card class="pb-3 mx-auto addLocationBg" rounded="xxl" style="text-align-last: center;" >-->
    <div style="display: grid; height: 90vh">
<!--      <v-img-->
<!--          class="white&#45;&#45;text align-end"-->
<!--          height="100px"-->
<!--          src="~@/assets/events_img_1.png"-->
<!--          position="top center"-->
<!--      >-->
        <v-card-title class="pb-0">Share With the Community</v-card-title>
        <v-card-subtitle class="mt-0 pb-1">Events, Recommendations And Anything Else</v-card-subtitle>
<!--      </v-img>-->


      <v-card-text class="my-3 date-picker-container">
<!--        <v-select :items="eventTypes" label="Type" style="width: 50vw"></v-select>-->
        <v-text-field style="width: 80vw" v-model="contributionTitle" label="Title"></v-text-field>
        <gmap-autocomplete class="hotspotAutoComplete" :key="autocompleteKey" @place_changed="initMarker" placeholder="Location" :value="existingPlace?.formatted_address"></gmap-autocomplete>
        <v-text-field style="width: 80vw" v-model="contributionTimeframe" label="Date\Time (Optional)"></v-text-field>
        <v-textarea style="width: 80vw;" v-model="contributionContent" label="Description"></v-textarea>
        <v-text-field style="width: 80vw" v-model="contributionUrl" label="Link (Optional)"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="ml-3" small @click="closeAddEventDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="mr-3" small @click="add_contribution">Share</v-btn>
      </v-card-actions>
    </div>
    <v-alert transition="scroll-y-transition" dismissible v-model="contributionCreationError" type="error" dense origin="top" border="right" style="position: fixed; top: 5vh">
      Error Adding Your Contribution
    </v-alert>
    <v-alert transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right" style="position: fixed; top: 5vh">
      We need more information!<br> Title, location and description are required.
    </v-alert>
  </div>
</template>

<script>
import {allMixins} from "@/mixins/allMixins";
import {store} from "@/store";
import supabase from "@/lib/supabaseClient";
import axios from "axios";

export default {

  name: "AddEvent",
  mixins: [allMixins],
  data() {
    return {
      autocompleteKey: 0,
      existingPlace: null,
      addedEventTitle: null,
      contributionCreationError: false,
      missingDataAlert: false,
      contributionTitle: '',
      contributionTimeframe: '',
      contributionContent: '',
      contributionUrl: '',
      eventTypes: [
        'Accommodation',
        'CoWorking',
        'Dancing',
        'CoLiving',
        'Activity',
        'Attraction',
        'Beach',
        'Food',
        'Hike',
        'Museum',
        'Park',
        'Shopping',
        'Sightseeing',
        'Tour',
        'Retreat',
        'Other',
      ]
    }
  },

  async mounted() {
    if (store.state.contributionToEdit) {
      this.contributionTitle = store.state.contributionToEdit.short_title
      this.contributionTimeframe = store.state.contributionToEdit.timeframe
      this.contributionContent = store.state.contributionToEdit.content
      this.contributionUrl = store.state.contributionToEdit.url
      // this.existingPlace = store.state.contributionToEdit.location_id
      this.existingPlace = await this.getGeoLocation(store.state.contributionToEdit.location_id.position.lat, store.state.contributionToEdit.location_id.position.lng)

    }
  },
  methods: {
    async getGeoLocation(latitude, longitude) {
      const axiosInstance = axios.create();

      try {

        // Call the Netlify function
        const netlifyFunctionURL = `/.netlify/functions/geocode?lat=${latitude}&lng=${longitude}`;

        const response = await axiosInstance.get(netlifyFunctionURL);

        return response.data.results[0];
      } catch (error) {
        // Handle errors (geolocation errors, network errors, etc.)
        console.error('Error getting geolocation:', error);
      }
    },
    closeAddEventDialog() {
      this.$emit('closeAddEventDialog');
      store.commit('setContributionToEdit', null)
      store.commit('setAddContributionVisibility', false)
    },
    addedHotspotDialogCancel() {
      this.hotspotAddedDialogVisible = false
      this.$emit('closeAddHotspotDialog');
    },
    addedHotspotDialogMore() {
      this.hotspotAddedDialogVisible = false
      this.autocompleteKey += 1
    },
    initMarker(loc) {
      this.existingPlace = loc;
    },

    async add_contribution() {
      let sufficientData = this.contributionTitle && this.existingPlace && this.contributionContent
      if (!sufficientData) {
        this.missingDataAlert = true
        return
      }
      store.commit('loadingOn')
      const alreadyExists = await this.checkRowExistence(this.existingPlace.place_id)
      let location_created = true
      if (alreadyExists) {
        console.log('location exists')
      } else {
        location_created = await this.createLocation()
      }
      if (!location_created) {
        this.contributionCreationError = true
        return
      }
      let upsertData = {
        "user_id": store.state.userData.userId,
        "short_title": this.contributionTitle,
        "content": this.contributionContent,
        "url": this.contributionUrl,
        "location_id": this.existingPlace.place_id,
        "timeframe": this.contributionTimeframe,
      }
      if (store.state.contributionToEdit) {
        upsertData['id'] = store.state.contributionToEdit.id
      }
      store.commit('setContributionToEdit', null)
      const { data, error } = await supabase
          .from('community')
          .upsert([
            upsertData,
          ])
          .select()

      store.commit('loadingOff')
      if (error) {
        console.log(error)
      } else {

        console.log(data)
        await store.dispatch('getUserContributions')
        await store.dispatch('getSocialData')
        store.commit('setAddContributionVisibility', false)

      }
    },
  },
}
</script>

<style>
.addLocationBg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}
.hotspotAutoComplete{
  background-color: #d9e4f6;
  border-radius: 15px;
  width: 80vw;
  text-align-last: center;
}
.date-picker-container {
  display: flex;
  justify-content: center; /* Aligns vertically center */
  align-items: center; /* Aligns horizontally center */
  flex-direction: column; /* Stack children vertically */
}

</style>
